<template>
    <bscroll-view>
        <div class="knowledge-book-rec">
            <div class="content-body">
                <div class="header-wrap">
                    <h5 class="name">
                        {{ langTransfer(baseData.name) }}
                    </h5>
                </div>
                <section class="common-resource-section knowledge-book-group">
                    <div class="resource-list">
                        <div v-for="(item,i) in baseData.list"
                             :key="i"
                             class="item"
                             @click="detailDispatcher('knowledgeBook',item,'collection')"
                        >
                            <div class="hb-resource-cover knowledge-item-cover lr-img-scale lr-high-light
                            lr-book-cover"
                            >
                                <img :src="item.poster">
                            </div>
                            <div class="name text1line">
                                {{ langTransfer(item.name) }}
                            </div>
                        </div>
                        <div class="item hb-spacebeteen-empty" />
                        <div class="item hb-spacebeteen-empty" />
                        <div class="item hb-spacebeteen-empty" />
                        <div class="item hb-spacebeteen-empty" />
                        <div class="item hb-spacebeteen-empty" />
                    </div>
                </section>
                <button v-show="baseData.list"
                        class="common-read-more lr-img-scale"
                        @click="goDetail"
                >
                    {{ langTransfer('查看更多') }}
                </button>
            </div>
            <footer-com />
        </div>
    </bscroll-view>
</template>

<script>
    import BscrollView from '@/components/bscrollView'
    import FooterCom from '@/components/footerCom/footerCom'
    import { recommendList } from '../../api/lyl'

    export default {
        name: 'Home',
        components: {
            FooterCom,
            BscrollView
        },
        data () {
            return {
                baseData: {}
            }
        },
        computed: {
            pageSetup () {
                return this.$store.state.pageSetup
            },
            webInfo () {
                return this.$store.state.webInfo
            }
        },
        watch: {
            webInfo (newVal) {
                if (newVal.service_code) {
                    this.recommendList()
                }
            }
        },

        created () {
        },
        mounted () {
            const { service_code } = this.webInfo
            if (service_code) {
                this.recommendList()
            }
        },
        methods: {
            goDetail () {
                const { id } = this.$route.params
                const { href } = this.$router.resolve({
                    name: 'knowledgeBookList',
                    params: { id }
                })
                window.open(href, '_blank')
            },
            async recommendList () {
                try {
                    const data = await recommendList({
                        service_code: this.webInfo.service_code,
                        unique_code: this.$route.params.id,
                        type: '2'
                    })
                    console.log(data)
                    this.baseData = data.find((e) => {
                        return e.type === 8
                    })
                } catch (err) {
                    this.baseData = {}
                    console.log(err)
                }
            }
        }
    }
</script>

<style scoped lang="less">
@media screen and (max-width: 10000px) {
  .hb-resource-cover{
      height: 240px;
  }
  .knowledge-book-group {
        .item {
            width: 180px;
            .hb-resource-cover {
                width: 180px;
            }
        }
  }
}
@media screen and (max-width: 1280px) {
  .hb-resource-cover{
      height: 206px;
  }
  .knowledge-book-group {
        .item {
            width: 154px;
            .hb-resource-cover {
                width: 154px;
            }
        }
  }
}
    .knowledge-book-rec {
        width: 100%;
        min-height: calc(100vh - 60px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .content-body {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .header-wrap {
            width: 1200px;
            margin: 50px 0 0;
        }

        .name {
            font-size: 16px;
            font-family: AlibabaPuHuiTiB;
            color: #303133;
            line-height: 16px;
            // font-weight: 600;
        }
    }

    .knowledge-book-group {
        width: 1200px;
        margin-top: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;

        .item {
            border-radius: 8px;
            margin-bottom: 20px;
            overflow: hidden;
            cursor: pointer;
            transition: .3s;

            .hb-resource-cover {
            }

            .name {
                font-size: 15px;
                font-family: AlibabaPuHuiTiM;
                color: #303133;
                line-height: 24px;
                margin-top: 10px;
            }
        }
    }

    .common-read-more {
        margin-top: 40px;
        margin-bottom: 80px;
    }
</style>
